export default __webpack_public_path__ + "static/media/Vanessa_Graves_AHV_In_Moms_We_Trust.1963ef9b.jpg";